import Typography from '@mui/material/Typography';
import {Completed} from '@vedmarket/ui-kit';
import MenuButton from 'components/common/menuButton';
import {getFlag} from 'components/cabinet/calculator/components/delivery/helpers';
import {COLORS} from 'config/constants';
import chinaFlag from 'assets/flags/china.svg';
import ProductSummary from './product-summary';

import './saved-product.scss';

const countryFlags: Record<string, string> = {
  CN: chinaFlag,
  CHN: chinaFlag,
  '156': chinaFlag,
};

const SavedProduct = ({product, position, info, actions}: SavedProductProps) => {
  const countryFlagSource = countryFlags[product.country_code?.toUpperCase()];
  const caption = <span className='saved-product__caption'>
    {getFlag({
      code: product.country_code,
      width: countryFlagSource ? 'auto' : '19px',
      height: '14px',
      source: countryFlagSource,
      marginRight: '0',
    })}
    <Typography component='span' variant='subtitle1' sx={{
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: 0,
      color: COLORS.BLACK_DARK,
    }}>
      {position}. {product.name}
    </Typography>
  </span>;

  return <div className='saved-product'>
    <Completed
      isFullRow
      info={info}
      onEdit={actions.onEdit}
      MenuComponent={MenuButton}
      onRemove={actions.onRemove}
      onCopy={actions.onCopy}
      preInfo={<ProductSummary product={product} onOpenPhoto={actions.onOpenPhoto} />}
      caption={caption}
      hasCollapse
      total={product.price_total}
    />
  </div>;
};

export default SavedProduct;
